import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from '@app/components/login/login-form/login-form.component';
import { LoginComponent } from '@app/components/login/login.component';
import { PageNotFoundComponent } from '@app/components/page-not-found/page-not-found.component';
import { EntitySelectorPageComponent } from '@app/components/profile/entity-selector-page/entity-selector-page.component';
import { FirstLogComponent } from '@app/components/profile/first-log/first-log.component';
import { IsLoggedGuard } from './guards/is-logged.guard';
import { EmailComponent } from './components/email/email.component';
import { EmailUnsubscribeComponent } from './components/email/email-unsubscribe/email-unsubscribe.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'first-log', component: FirstLogComponent, canActivate: [IsLoggedGuard] },
    { path: 'entity-selection', component: EntitySelectorPageComponent, canActivate: [IsLoggedGuard] },
    {
        path: 'backoffice',
        loadChildren: () => import('./components/backoffice/backoffice.module').then((mod) => mod.BackofficeModule),
        canActivate: [IsLoggedGuard],
    },
    {
        path: 'email/unsubscribe',
        component: EmailComponent,
        children: [{ path: '', component: EmailUnsubscribeComponent }],
    },
    {
        path: 'consent-page',
        loadChildren: () =>
            import('./components/consent-module/consent-module.module').then((mod) => mod.ConsentModuleModule),
        canActivate: [IsLoggedGuard],
    },
    {
        path: 'login',
        component: LoginComponent,
        children: [
            { path: '', component: LoginFormComponent },
            { path: 'collab', component: LoginFormComponent },
            { path: 'reset-password', redirectTo: 'password/reset' },
            {
                path: 'password',
                loadChildren: () => import('./components/password/password.module').then((mod) => mod.PasswordModule),
            },
        ],
    },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
